import { RouteObject } from 'react-router'
import { OnboardingRoutePath } from './public'
import { BusinessDetailsPage } from '../pages/business-details'
import { IncompleteOnboardingOnly } from '../components/guards/incomplete-onboarding-only'

export const protectedOnboardingRoutes: RouteObject[] = [
  {
    path: OnboardingRoutePath.BusinessDetails,
    element: (
      <IncompleteOnboardingOnly>
        <BusinessDetailsPage />
      </IncompleteOnboardingOnly>
    ),
  },
]
